import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1cebbac4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dashboard-page common-page flex-center"
};
import { useRoute, useRouter } from 'vue-router';
import { getUserPermissionApi } from '@/service/modules/login';
export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const get_userinfo = async () => {
      let res = await getUserPermissionApi();
    };
    get_userinfo();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, " 首页，会话存档内容 ");
    };
  }
});